import React, { useEffect, useState } from 'react'
import SectionContainer from '../../../Homepage/SectionContainer'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import { Col, Container, Row } from 'reactstrap';
// import aboutImg from "../../../assets/kangaroo/aboutUsweb.webp"
import TimerModal from '../../../component/TimerModal/TimerModal';
import "../About.css"
import MessageService from '../../../services/MesssageService';
import { useLocation } from 'react-router-dom';
import { imageBaseApi } from '../../../services/imageBaseApi';
import PageService from '../../../services/PageService';
const AboutDirector = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter(Boolean).pop();

  const [data, setData] = useState();
  console.log("🚀 ~ AboutMessage ~ data:", data)
  const fetchData = async () => {
    try {
      const response = await PageService.getbySlug(path);
      console.log("🚀 ~ fetchData ~ response:", response)
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [location]);
  return (
    <SectionContainer>
      <Container fluid>
        <Row>
          <Col className='my-4'>
            <BreadCrumb items={[
              { title: "HOME", link: "/" },
              { title: "ABOUT", link: "#" },
              { title: "MESSAGE FROM DIRECTOR" },
            ]} instituition={false} className="" />
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            <h1 className='font-level-4 lh-1' style={{ marginBottom: "4.5rem" }}>{data?.title}</h1>
          </Col>
        </Row>
        <Row className='align-items-center '>
          <Col lg={6} sm={12}><img src={`${imageBaseApi}${data?.featuredMedia?.url}`} className="w-100 h-100 mb-4 mb-md-0" alt="" fluid /></Col>
          <Col lg={6} sm={12}>

            <p className='about-intro-font '>
              {data?.subtitle}</p></Col>
        </Row>
        <Row  >
          <Col style={{ marginTop: "3.7rem", marginBottom: "18rem" }}>
            <p className='country-paragraph-text ' dangerouslySetInnerHTML={{ __html: data?.content }}>

            </p>
          </Col>
        </Row>

      </Container>
    </SectionContainer>
  )
}

export default AboutDirector
